// extracted by mini-css-extract-plugin
export default {"dropdownContent":"SearchDropdownOverlay_dropdownContent__O3GDN"};